import Vue from "vue";
import App from "@/vue/App.vue";
import "@/vue/plugins/bootstrap-vue";
import "@/vue/styles/global.scss";
import "@/vue/plugins/react";
import { router } from "@/vue/router";
import VueGtag from "vue-gtag";
import VueFlags from "@growthbunker/vueflags";
import Vuelidate from "vuelidate";
import store from "@/vue/store";

import { axiosInstance, smpAxiosInstance } from "@/vue/api/api";

import moment from "moment";
import "@/vue/plugins/lodash";
import { formatDate } from "@/vue/utils/helper";
import IWGLogo from "@/vue/components/icons/IWGLogo";
import SIPIcon from "@/vue/components/icons/SIPIcon";
import PBXIcon from "@/vue/components/icons/PBXIcon";
import { addEventListener, EVENT_TYPES } from "@/events";
import { getEnv } from "@/env";

Vue.use(VueFlags);
Vue.use(Vuelidate);

window.moment = moment;

Vue.config.productionTip = false;
Vue.config.productionSourceMap = true;

Vue.prototype.$http = axiosInstance;
Vue.prototype.$smphttp = smpAxiosInstance;

window.EventBus = new Vue();

// Expose router and store to the window object for debugging purposes
if (getEnv("VUE_APP_NODE_ENV") !== "production") {
  window.router = router;
  window.store = store;
}

Vue.filter("formatDate", formatDate);

Vue.component("IWGLogo", IWGLogo);
Vue.component("SIPIcon", SIPIcon);
Vue.component("PBXIcon", PBXIcon);

Vue.use(
  VueGtag,
  {
    config: {
      id: getEnv("VUE_APP_GTAG_ID"),
    },
  },
  router
);

addEventListener(EVENT_TYPES.SYNC_USER, (e) => {
  const { detail: user } = e;
  if (!user) {
    return;
  }
  store.dispatch("setUser", user);
});

const vueApp = new Vue({
  history: true,
  router,
  store,
  render: (h) => h(App),
});

export const renderVue = (el) => vueApp.$mount(el);
